import * as S from "./Modals.style";
import { useRef } from "react";

export interface ModalProps {
  text?: React.ReactElement;
  title?: string | React.ReactNode;
  children?: React.ReactElement;
  setModalShow?: any;
  modalButtons?: React.ReactElement;
}

export const Modals = (props: ModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const modalOutsideClick = (e: any) => {
    if (modalRef.current === e.target) {
      return props.setModalShow(false);
    }
  };
  return (
    <S.ModalBg ref={modalRef} onClick={(e: any) => modalOutsideClick(e)}>
      <S.Modals>
        {props.title && <S.ModalTitle>{props.title}</S.ModalTitle>}
        {props.text && <S.ModalText>{props.text}</S.ModalText>}
        {props.children && <S.ModalContent>{props.children}</S.ModalContent>}
        <S.ModalButtons>{props.modalButtons}</S.ModalButtons>
      </S.Modals>
    </S.ModalBg>
  );
};
